import { CapitalOperationalExpenditureBase } from './base/capital-operational-expenditure-base';

export class CapitalOperationalExpenditure extends CapitalOperationalExpenditureBase { }